module.exports = __webpack_public_path__ + "img/periodo.983bed69.png";